import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import { InputBase } from '../../Helper/InputBase';
import { formatter, validate } from '../../../utility';
import { NormalizationConstants } from '../../../constants';
import { restartIcon, appliedRuleIcon } from '../../../assets/images';
import GeneralUtils from '../../../utility/GeneralUtils';
import moment from 'moment';
import { RentIncreaseBreakdown } from './RentIncreaseBreakdown';

const MAX_PORTION_PERCENTAGE = 0.03;
const PERCENT_TO_VALUE_MULTIPLIER = 0.01;

class StepThree extends Component {
  state = {
    rentCPIAmountStandardRentIncrease: '', 
    rentAmountStandardRentIncrease: '',
    rentMaxAmountAdditionalPortion: '',
    rentAmountAdditionalPortion: '',
    rentAmountFinalAdditionalRentIncrease: '',
    phaseOneRemainingEligibleAmount: '',

    selectedRentIncreaseAmount: '',


    errors: {
      aawds: ''
    }
  }

  componentDidMount() {
    const { stepOneData, stepTwoData, stepThreeData, submitted } = this.props;

    const calcCPIValue = stepTwoData.calcCPIValue ? stepTwoData.calcCPIValue : {};
    const cpiPercent = (Number(calcCPIValue.value) * PERCENT_TO_VALUE_MULTIPLIER);
    const rentAmountUsedForCalc = Number(stepOneData.rentAmountUsedForCalc);
    const rentCPIAmountStandardRentIncrease = formatter.toFixedNumber((rentAmountUsedForCalc * cpiPercent), 2);
    const decisionEligibleAmount = Number(stepOneData.decisionEligibleAmount);
    const rentAmountStandardRentIncrease = formatter.toFixedNumber(rentCPIAmountStandardRentIncrease + rentAmountUsedForCalc, 2);
    const rentMaxAmountAdditionalPortion = formatter.toFixedNumber((rentAmountStandardRentIncrease * MAX_PORTION_PERCENTAGE), 2);
    const rentAmountAdditionalPortion = Math.min(decisionEligibleAmount, rentMaxAmountAdditionalPortion);
    const rentAmountFinalAdditionalRentIncrease = formatter.toFixedNumber(rentAmountStandardRentIncrease + rentAmountAdditionalPortion, 2);
    const phaseOneRemainingEligibleAmount = formatter.toFixedNumber((decisionEligibleAmount - rentAmountAdditionalPortion), 2);

    this.setState({
      rentCPIAmountStandardRentIncrease,
      rentAmountStandardRentIncrease,
      rentMaxAmountAdditionalPortion,
      rentAmountAdditionalPortion,
      rentAmountFinalAdditionalRentIncrease,
      phaseOneRemainingEligibleAmount,
      selectedRentIncreaseAmount: stepThreeData.selectedRentIncreaseAmount || ''
    }, () => {
      if ((stepOneData.calcRentIncreaseCausedLoss || !stepOneData.calcRentIncreaseServiceTimeIsAvailable) && !submitted) this.submitStepThree();
    });

  }

  modifyClicked = () => {
    this.props.setStepThreeStatus(false);
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      errors: { ...this.state.errors, [name]: '' },
    });
  };

  submitStepThree = () => {
    const { selectedRentIncreaseAmount, rentAmountFinalAdditionalRentIncrease } = this.state;
    const { setStepThreeStatus, stepOneData } = this.props;
    const hideRIAmount = stepOneData.calcRentIncreaseCausedLoss || !stepOneData.calcRentIncreaseServiceTimeIsAvailable;
    const validationArray = [{
      selectedRentIncreaseAmount,
      validationRules: [
        !hideRIAmount ? { minValue: stepOneData.rentAmountUsedForCalc } : {},
        !hideRIAmount ? { maxValue: rentAmountFinalAdditionalRentIncrease } : {},
        { isRequired: !hideRIAmount, errorMsg: 'New rent amount is required' },
      ]
    }];

    let err = validate(validationArray);
    console.log('err: ', err);
    if (Object.keys(err).length >= 1) {
      this.setState({ errors: err });
    } else {
      this.setStepThreeVars();
      setStepThreeStatus(true);
    }
  }

  getIsGeneratedNoticeAvailable = () => {
    const { stepOneData, stepTwoData } = this.props;
    const { phaseOneRemainingEligibleAmount } = this.state;

    if((stepOneData.calcRentIncreaseCausedLoss && phaseOneRemainingEligibleAmount <= 0) || (!stepOneData.calcRentIncreaseServiceTimeIsAvailable && phaseOneRemainingEligibleAmount <= 0) || !stepTwoData.calcCPIValue) return false;
    else return true;
  }

  setStepThreeVars = () => {
    const { rentCPIAmountStandardRentIncrease, rentAmountStandardRentIncrease, rentMaxAmountAdditionalPortion, rentAmountAdditionalPortion, rentAmountFinalAdditionalRentIncrease, phaseOneRemainingEligibleAmount, selectedRentIncreaseAmount } = this.state;
    const { stepTwoData, setStepThreeVars } = this.props;

    const phaseOneLostEligibleAmount = this.getPhaseOneLostEligibleAmount();
    const isGeneratedNoticeAvailable = this.getIsGeneratedNoticeAvailable();
    const inPersonMinServiceDate = moment(stepTwoData.selectedRentIncreaseDate).subtract(3, 'months').subtract(1, 'days').toDate() ;
    const emailDoorFaxMinServiceDate = moment(stepTwoData.selectedRentIncreaseDate).subtract(3, 'months').subtract(4, 'days').toDate();
    const regMailMinServiceDate = moment(stepTwoData.selectedRentIncreaseDate).subtract(3, 'months').subtract(6, 'days').toDate(); 

    const stepThreeVars = {
      rentCPIAmountStandardRentIncrease,
      phaseOneRemainingEligibleAmount,
      phaseOneLostEligibleAmount,
      isGeneratedNoticeAvailable,
      selectedRentIncreaseAmount,
      rentAmountAdditionalPortion,
      inPersonMinServiceDate,
      regMailMinServiceDate,
      emailDoorFaxMinServiceDate,
      rentAmountFinalAdditionalRentIncrease,
      rentAmountStandardRentIncrease,
      rentMaxAmountAdditionalPortion
    };
    
    GeneralUtils.log('----- PRINTING ALL STEP 3 VARIABLES -----', 'success');
    GeneralUtils.log(`
      rentCPIAmountStandardRentIncrease: ${rentCPIAmountStandardRentIncrease}\n
      rentAmountStandardRentIncrease: ${rentAmountStandardRentIncrease}\n
      rentMaxAmountAdditionalPortion: ${rentMaxAmountAdditionalPortion}\n
      rentAmountAdditionalPortion: ${rentAmountAdditionalPortion}\n
      rentAmountFinalAdditionalRentIncrease: ${rentAmountFinalAdditionalRentIncrease}\n
      phaseOneRemainingEligibleAmount: ${phaseOneRemainingEligibleAmount}\n
      phaseOneLostEligibleAmount: ${phaseOneLostEligibleAmount}\n
      isGeneratedNoticeAvailable: ${isGeneratedNoticeAvailable}\n
      inPersonMinServiceDate: ${formatter.toDateDisplay(inPersonMinServiceDate)}\n
      emailDoorFaxMinServiceDate: ${formatter.toDateDisplay(emailDoorFaxMinServiceDate)}\n
      regMailMinServiceDate: ${formatter.toDateDisplay(regMailMinServiceDate)}
    `, 'info');

    setStepThreeVars(stepThreeVars);
  }

  getPhaseOneLostEligibleAmount() {
    const { rentAmountFinalAdditionalRentIncrease, selectedRentIncreaseAmount, rentMaxAmountAdditionalPortion } = this.state;
    if ((rentAmountFinalAdditionalRentIncrease - selectedRentIncreaseAmount) <= (rentMaxAmountAdditionalPortion)) {
      return formatter.toFixedNumber(rentAmountFinalAdditionalRentIncrease - selectedRentIncreaseAmount, 2);
    } else {
      return formatter.toFixedNumber(rentMaxAmountAdditionalPortion, 2);
    }
  }

  render = () => {
    const {
      rentCPIAmountStandardRentIncrease,
      rentAmountStandardRentIncrease,
      rentAmountAdditionalPortion, 
      rentAmountFinalAdditionalRentIncrease, 
      selectedRentIncreaseAmount,
      rentMaxAmountAdditionalPortion,
      errors 
    } = this.state;
    const { submitted, stepOneData, stepTwoData } = this.props;

    const calcRentIncreaseCausedLoss = stepOneData.calcRentIncreaseCausedLoss;
    const calcRentIncreaseServiceTimeIsAvailable = stepOneData.calcRentIncreaseServiceTimeIsAvailable;
    const calcMissedRentIncreaseDate = stepOneData.calcMissedRentIncreaseDate;
    const cpiValue = stepTwoData.calcCPIValue ? stepTwoData.calcCPIValue.value : 0;
    const cpiYear = stepTwoData.calcCPIValue ? stepTwoData.calcCPIValue.year : 0;
    
    const renderButtons = () => {

      const renderModifyButton = () => submitted ? <span className="w1-step-one__modify" onClick={() => this.modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null;

      if (stepOneData.calcRentIncreaseCausedLoss || !stepOneData.calcRentIncreaseServiceTimeIsAvailable) return;

      return (
        <div className="w1-step-one__buttons hide-print">
          <Button variant="primary" className="step1-continue" onClick={() => this.submitStepThree()} disabled={submitted}>Continue</Button>
          {renderModifyButton()}
        </div>
      )
    }
    
    const renderRentIncreaseAmount = () => {
      if (stepOneData.calcRentIncreaseCausedLoss || !stepOneData.calcRentIncreaseServiceTimeIsAvailable) return;

      return (
        <InputBase
          name='selectedRentIncreaseAmount'
          startAdornment='$'
          disabled={submitted}
          errors={errors.selectedRentIncreaseAmount}
          value={selectedRentIncreaseAmount}
          cssClass='w1-step-three__rent-amount'
          type='number'
          label={`What is the new rent amount that will be implemented on ${formatter.toDateDisplay(stepTwoData.selectedRentIncreaseDate)}?`}
          maxLength={NormalizationConstants.maxDollarLength}
          handleChange={this.handleChange}
        />
      );
    }

    return (
      <div className="w1-step-three">
        <div className="">
          <p className="w1-step-three__header">First Additional Rent Increase Breakdown</p>
          <RentIncreaseBreakdown 
              decisionEligibleAmount={Number(stepOneData.decisionEligibleAmount)} 
              rentAmountUsedForCalc={Number(stepOneData.rentAmountUsedForCalc)} 
              rentCPIAmountStandardRentIncrease={rentCPIAmountStandardRentIncrease}
              rentAmountStandardRentIncrease={rentAmountStandardRentIncrease}
              rentAmountAdditionalPortion={rentAmountAdditionalPortion}
              rentAmountFinalAdditionalRentIncrease={rentAmountFinalAdditionalRentIncrease}
              rentMaxAmountAdditionalPortion={rentMaxAmountAdditionalPortion}
              calcRentIncreaseCausedLoss={calcRentIncreaseCausedLoss}
              calcRentIncreaseServiceTimeIsAvailable={calcRentIncreaseServiceTimeIsAvailable}
              calcMissedRentIncreaseDate={calcMissedRentIncreaseDate}
              cpiValue={cpiValue}
              cpiYear={cpiYear}
          />
          <p className="w1-step-three__rule">
            <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
            <span>
              <b>Applied Rule</b>: The maximum additional rent increase amount that can be applied to a rent increase is the lesser amount between 3% of the rent (after the maximum annual allowable increase is calculated), or the eligible amount for the unit. 
              <span className="w1-step-three__rule--success">&nbsp;The maximum additional rent increase amount for this rent increase is <b>{formatter.toAmountDisplay(rentAmountAdditionalPortion)}</b>.</span>
            </span>
          </p>

          { renderRentIncreaseAmount() }

        </div>
        {renderButtons()}
      </div>
    );
  }
}

export default StepThree;